import { castToOption } from 'src/helpers/castToOption';

export enum PaymentMethod {
  Check = 'CHECK',
  Ach = 'ACH',
}

export const PAYMENT_METHODS_MAPPER: Record<PaymentMethod, string> = {
  [PaymentMethod.Check]: 'Check',
  [PaymentMethod.Ach]: 'ACH',
};

/**
 * Order matters!
 *
 * It used only in one place. There is no need to create custom options with desired order right now
 */
export const paymentMethodsOptions = castToOption(PaymentMethod, PAYMENT_METHODS_MAPPER);
